/** @jsx jsx */
import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { jsx, css } from '@emotion/core'
import { SubmissionError } from 'redux-form'

import NewPasswordForm from './NewPasswordForm'

import { setPassword, loggedInUser } from '../actions/auth'
import { default_theme as theme } from '../emotion/theme'
import npo_connect_logo from '../images/npo-connect-landscape.png'

class Login extends Component {

    componentDidMount() {
        const { user, history } = this.props
        if (user.has_usable_password) {
            history.push('/dashboard')
        }
    }
    
    handleSubmit = (values) => {
        const { dispatch, history } = this.props
        const on_done = function() {
            history.push('/dashboard')
        }
        if (values.password !== values.confirm_password) {
            throw new SubmissionError({confirm_password: "Passwords do not match"})
        } else {
            return dispatch(setPassword(values, on_done))
        }
    }

    render() {
        return (
            <div css={ main }>
              <div css={ container }>
                <div css={ header }>
                  <img src={ npo_connect_logo } alt="" css={ image } />
                  <p>This is your first time logging in, please choose a password.</p>
                </div>
                <NewPasswordForm
                    onSubmit={ this.handleSubmit }
                />
              </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    const user = loggedInUser()
    return {
        user
    }
}
export default withRouter(connect(mapStateToProps)(Login))

const main = css`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background-color: ${theme.colors.gray2};
min-height: 100vh;
padding: 0 16px;
`

const container = css`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
max-width: 520px;
width: 100%;
background-color: ${theme.colors.white};
box-shadow: 10px 10px 30px 0px #888888;
`

const header = css`
padding-top: 30px;
width: 80%;
text-align: center;
p {
    padding-top: 20px;
}
`

const image = css`
width: 80%;
`
